module.exports = __webpack_public_path__ + "static/media/pic_banner_friend.7eb5c233.jpg";